(function () {
  if (window.__jwShop) return;
  window.__jwShop = true;
  var Q = '';
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  var BAD = ['inherit', 'initial', 'unset', 'revert', 'transparent', 'currentcolor'];
  function kwOf(el) { return (el.getAttribute('data-kw') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean); }
  function match(card, kws) {
    var n = card.getAttribute('data-name') || '';
    if (Q && n.indexOf(Q) < 0) return false;
    if (!kws.length) return true;
    return kws.some(function (k) { return n.indexOf(k) > -1; });
  }
  function swatches() {
    $$('.jw-sw[data-vals]').forEach(function (el) {
      if (el.getAttribute('data-done')) return;
      el.setAttribute('data-done', '1');
      var out = [], n = 0;
      (el.getAttribute('data-vals') || '').split('|').forEach(function (v) {
        var col = null;
        v.toLowerCase().split(/[^a-z]+/).forEach(function (w) {
          if (!col && w && BAD.indexOf(w) < 0 && window.CSS && CSS.supports('color', w)) col = w;
        });
        if (col) { n++; if (out.length < 4) out.push('<i style="background:' + col + '"></i>'); }
      });
      if (out.length) el.innerHTML = out.join('') + (n > 4 ? '<b>+' + (n - 4) + '</b>' : '');
    });
  }
  function chipImages() {
    var cards = $$('.jw-card');
    $$('.jw-chip[data-kw], .jw-tile[data-kw]').forEach(function (ch) {
      var holder = $('.jw-chip-img, .jw-tile-img', ch), kws = kwOf(ch);
      if (!holder || !kws.length || holder.querySelector('img')) return;
      for (var i = 0; i < cards.length; i++) {
        var src = $('.jw-img-main', cards[i]);
        if (src && match(cards[i], kws)) {
          var img = document.createElement('img');
          img.src = src.currentSrc || src.src; img.alt = ''; img.loading = 'lazy';
          holder.textContent = ''; holder.appendChild(img);
          break;
        }
      }
    });
  }
  function apply() {
    var on = $('.jw-chip.on'), kws = on ? kwOf(on) : [], shown = 0;
    $$('.jw-card').forEach(function (c) { var ok = match(c, kws); c.hidden = !ok; if (ok) shown++; });
    var none = $('.jw-none'); if (none) none.hidden = shown > 0;
    var n = $('.jw-count-n'); if (n) n.textContent = shown;
    var tr = $('.jw-grid'); if (tr) { tr.scrollLeft = 0; sl(); }
  }
  document.addEventListener('click', function (e) {
    var ch = e.target.closest ? e.target.closest('.jw-chip, .jw-tile') : null;
    if (!ch) return;
    if (ch.classList.contains('jw-tile')) {      // a category tile acts like the matching tab
      var want = ch.getAttribute('data-kw'), tab = null;
      $$('.jw-chip').forEach(function (b) { if (b.getAttribute('data-kw') === want) tab = b; });
      if (!tab) return;
      ch = tab;
    }
    $$('.jw-chip').forEach(function (b) { var is = b === ch; b.classList.toggle('on', is); b.setAttribute('aria-pressed', is ? 'true' : 'false'); });
    apply();
    var t = document.getElementById('jewelry-products');
    if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  /* slider: progress bar + arrows under the products */
  function sl() {
    var tr = $('.jw-grid'), ctrl = $('.jw-ctrl');
    if (!tr || !ctrl) return;
    var th = $('.jw-thumb', ctrl), pv = $('.jw-prev', ctrl), nx = $('.jw-next', ctrl);
    var max = tr.scrollWidth - tr.clientWidth;
    ctrl.hidden = max < 4;
    if (ctrl.hidden) return;
    var w = tr.clientWidth / tr.scrollWidth * 100;
    var pos = Math.min(1, Math.max(0, Math.abs(tr.scrollLeft) / max));
    th.style.width = w + '%';
    th.style.insetInlineStart = (pos * (100 - w)) + '%';
    pv.disabled = pos <= 0.01;
    nx.disabled = pos >= 0.99;
  }
  function slBind() {
    var tr = $('.jw-grid');
    if (!tr || tr.getAttribute('data-sl')) return;
    tr.setAttribute('data-sl', '1');
    tr.addEventListener('scroll', function () { requestAnimationFrame(sl); }, { passive: true });
    window.addEventListener('resize', sl);
    sl();
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('.jw-arrow') : null;
    var tr = $('.jw-grid');
    if (!b || !tr) return;
    var dir = getComputedStyle(tr).direction === 'rtl' ? -1 : 1;
    tr.scrollBy({ left: (b.classList.contains('jw-next') ? 1 : -1) * dir * tr.clientWidth * 0.9, behavior: 'smooth' });
  });
  function init() { swatches(); chipImages(); slBind(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  /* used by the Shop page: pick a tab by its words, and filter by the search box */
  window.__jwSync = function (q, kw) {
    Q = (q || '').trim().toLowerCase();
    var want = (kw || '').toLowerCase(), tab = null;
    $$('.jw-chip').forEach(function (b) { if ((b.getAttribute('data-kw') || '') === want) tab = b; });
    if (!tab) tab = $('.jw-chip');
    $$('.jw-chip').forEach(function (b) { var is = b === tab; b.classList.toggle('on', is); b.setAttribute('aria-pressed', is ? 'true' : 'false'); });
    apply();
  };
  window.__jwSl = sl;
  document.addEventListener('shopify:section:load', init);
})();
